import * as React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import Layout from 'antd/lib/layout';
import { connect } from 'react-redux';
import { IStateApp } from '../../Reducers/index';
import { ISessionState, EStatusRequest } from '../../Reducers/Session';
import LogIn from '../../Containers/LogIn';
import ActionCreate, { createActionRecovery, createActionStatus, createActionRecoveryPass, createActionAccount } from '../../Actions/Session/Actions';
import { ICredencial, IProfile, IPassword, Recovery } from '../../Models/Security';
import SideBar from './SideBar';
import NavBar from './NavBar';
import './Layout.scss';
import Loading from '../Loading';
import Scrollbars from 'react-custom-scrollbars';
import { IAccount } from '../../Models/Account';
import { createActionChangePassword } from '../../Actions/Session/Actions';
import ChangePass from '../Profile/ChangePass';
import ServiceWrapper from '../../Services/ServiceWrapper';
import notification  from 'antd/lib/notification';

interface ILayoutProps extends ISessionState, RouteComponentProps {
	profile?: IProfile;
	onLogin: (cred: ICredencial) => void;
	onChecking: () => void;
	onChangePass: (password: IPassword) => void;
	onRecovery: (data: Recovery) => void;
	status: EStatusRequest;
	setStatus: (status: EStatusRequest) =>  void;
	onRecoverPass: (password: IPassword) =>  void,
	onAccount: () => void
}

class LayoutComponent extends React.Component<ILayoutProps> {
	render() {
		if ((!this.props.account || !this.props.profile) && this.props.isAuthorize) {
			return <Loading />
		}
		if (!this.props.isAuthorize) {
			return <Router basename="/seguimiento">
				<Switch>
					<Route path="/recovery" render={props => {
						const params = new URLSearchParams(props.location.search);
						if (params.get('authCode')) {
							ServiceWrapper.setToken(params.get('authCode')!);
							if (this.props.status === EStatusRequest.PENDING && !this.props.account) {
								this.props.setStatus(EStatusRequest.PROCESS);
								this.props.onAccount();
								return <Loading />
							} else {
								if (this.props.account && this.props.status === EStatusRequest.PROCESS) {
									this.props.setStatus(EStatusRequest.PENDING);
								} else {
									if (this.props.error) {
										notification.error({
											message: 'Recuperación de usuario',
											description: 'El tiempo para recuperacion se ha excedido'
										});
										setTimeout(() => {
											this.goLogin();	
										}, 1000);
									}
								}
								if (this.props.status === EStatusRequest.PROCESS) {
									return <Loading />
								}
							}
						} else {
							return <Redirect to="/" />
						}
						return <ChangePass hiddenOld={true} onClose={() => { this.goLogin() }} email="" onChange={this.props.onRecoverPass} isOpen={true} />
					}} />
					<Route path="/" render={props => <LogIn {...this.props} /> } />
				</Switch>
			</Router>
		}
		return <Router basename="/seguimiento">
			<Layout hasSider={false}>
				<NavBar onChangePass={this.onChange.bind(this)} account={this.props.account as IAccount} profile={this.props.profile} />
				{this.renderContent()}
			</Layout>
		</Router>;
	}

	componentDidMount() {
		this.props.onChecking();
	}

	private goLogin = () => {
		window.location.href = '/seguimiento';
	}

	private renderContent() {
		return <Layout.Content className="content">
			<SideBar isAdmin={this.props.account && this.props.account.idProfile === 1} />
			<Layout>
				<Scrollbars>
					<div className="content-container">{this.props.children}</div>
				</Scrollbars>
			</Layout>
		</Layout.Content>;
	}

	private onChange(data: any)  {
		const res: IPassword = {
			passwordCurrent: data.passwordOld,
			passwordNew: data.passwordNew
		};
		this.props.onChangePass(res);
	}
}
const mapProps = (state: IStateApp) => ({...state.session, profile: state.profile.current });

const mapActions = {
	onLogin: ActionCreate.auth,
	onChecking: ActionCreate.checking,
	onChangePass: createActionChangePassword,
	onRecovery: createActionRecovery,
	setStatus: createActionStatus,
	onRecoverPass: createActionRecoveryPass,
	onAccount: createActionAccount,
}

export default connect<ILayoutProps>(mapProps as any, mapActions)(LayoutComponent) as any;
